import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse
       } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ProgressType
       } from 'app/controls/progress-overlay/progress-overlay.component';
import { Button, ButtonsAssignment
       } from 'app/dialogs/dialog-buttons.component';
import { ProductDesignerService } from 'app/product-designer.service';
import { ConfigService } from 'core/config/config.service';
import { TrivialError } from 'core/error/error';
import { timeout } from 'rxjs/operators';
import { Utils } from '../utils';

const PIPELINE_TIMEOUT = 5 * 60 * 1000; // 5min

export class TraudlLoadingError extends TrivialError
{
  // i18n.error.traudlLoadingError.title
  // i18n.error.traudlLoadingError.message
  protected _name: string = 'TraudlLoadingError';

  public get buttons(): ButtonsAssignment
  {
    return {
      primary: Button.RETRY,
      secondary: Button.CHOOSE_OTHER_PHOTO,
    };
  }
}

@Injectable()
export class TraudlService
{
  private traudlURL: string;
  private disposition: string;

  constructor(private http: HttpClient,
              configService: ConfigService,
              @Inject(ProductDesignerService)
                  private productDesignerService: ProductDesignerService)
  {
    const config = configService.getProductDesignerComponentConfig();
    this.traudlURL = config.traudlURL;
    this.disposition = config.galleryImageDisposition;
  }

  private static describeError(err: any): string
  {
    if (err instanceof HttpErrorResponse) {
      return `[${err.status} ${err.statusText}] ${err.url}`;
    }

    if (err instanceof Error) {
      return `${err.name}: ${err.message}`;
    }

    return err.to_string();
  }

  /**
   * @throws TraudlLoadingError
   */
  public async loadPipelinedUrl(pipelineName: string,
                                resiLocation: string): Promise<string>
  {
    this.productDesignerService.suspendDesignerTrigger.emit({
      suspend: true,
      progressType: ProgressType.Progress,
    });

    try {
      const response = await this.http.post(
        `${this.traudlURL}/pipelines/${pipelineName}` +
          `?location=${encodeURIComponent(resiLocation)}`,
        {},
        {
          observe: 'response',
          responseType: 'text',
          headers: new HttpHeaders({
            'image-disposition': this.disposition
          })
        }
      ).pipe(
        timeout(PIPELINE_TIMEOUT),
        Utils.retryPipe()
      ).toPromise() as HttpResponse<any>;
      return response.headers.get('Location');
    } catch (err) {
      throw new TraudlLoadingError(
          TraudlService.describeError(err), [ pipelineName, resiLocation ]);
    } finally {
      this.productDesignerService.suspendDesignerTrigger.emit({
        suspend: false,
        progressType: ProgressType.Progress,
      });
    }
  }
}
